import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ToasterService } from '@frontend/sports/toaster/feature';

@Injectable({ providedIn: 'root' })
export class AlertToastMessagesService {
    private toaster = inject(ToasterService);
    private sitecore = inject(Sitecore);

    private timeout: number;
    constructor() {
        this.timeout = 3000;
    }

    showUnsubscribedToast(): void {
        if (this.sitecore.nativeAlerts) {
            this.startToast(this.sitecore.nativeAlerts.messages.LiveNotificationsUnsubscribed);
        }
    }

    showSubscribedToast(): void {
        if (this.sitecore.nativeAlerts) {
            this.startToast(this.sitecore.nativeAlerts.messages.LiveNotificationsSubscribed);
        }
    }

    private startToast(toast: string): void {
        this.toaster.open(toast, { duration: this.timeout });
    }
}
